import { render } from "./order_receipt.vue?vue&type=template&id=368f4c56&scoped=true"
import script from "./order_receipt.vue?vue&type=script&lang=js"
export * from "./order_receipt.vue?vue&type=script&lang=js"

import "./order_receipt.vue?vue&type=style&index=0&id=368f4c56&scoped=true&lang=css"
import "./order_receipt.vue?vue&type=style&index=1&id=368f4c56&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-368f4c56"]])

export default __exports__